export enum SUMMARY_TYPE {
  TOTAL_TRANSACTION = 'Total {type} Exceptions',
  DECISIONS_NEEDED = '{type} Exceptions – Decisions Needed',
  DECISIONED = `{type} Exceptions Decisioned`,
}

export enum SUMMARY_TYPE_GROUP_TABLE {
  DECISIONS_NEEDED = 'Decisions Needed',
  DECISIONED = 'Exceptions Decisioned',
}